// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SSd9","toggleWrap":"styles_toggleWrap__yuxyN","content":"styles_content__1TJwA","selectAreaCode":"styles_selectAreaCode__1w4HZ"};